import { z } from "zod"

const ERROR = {
  name: "Please enter a valid name",
  email: "Please enter a valid email address",
  telephone: "Please enter a valid phone number",
  message: "Please enter a valid message",
}

export const SUCCESS_MSG =
  "Thank you for contacting me. I will contact you shortly."

const SCHEMA = {
  name: z.string({ message: ERROR.name }).min(1, { message: ERROR.name }),
  email: z.string().email({ message: ERROR.email }),
  telephone: z
    .number({ message: ERROR.telephone, invalid_type_error: ERROR.telephone })
    .int({ message: ERROR.telephone })
    .min(4, { message: ERROR.telephone }),
  message: z.string({ message: ERROR.message }),
}

export const contactFormSchema = z.object({
    name: SCHEMA.name,
    email: SCHEMA.email,
    telephone: SCHEMA.telephone,
    message: SCHEMA.message
  })